export default __webpack_public_path__ + "static/media/modelo_web_villa_juncal.f926a35a.pdf";